<ph-skeleton *ngIf="isLoading"
             shape="list"
             rows="4"
             avatar="false"
             label="Loading folders"
             data-test="folder-picker-loading"></ph-skeleton>

<ph-alert *ngIf="hasFailed && !isLoading" status="error" data-test="folder-picker-error">
    <span>Couldn't load your document folders.</span>
    <ph-link-button variant="primary" (click)="load()">Try again</ph-link-button>
</ph-alert>

<ph-stack *ngIf="!isLoading && !hasFailed" gap="snug">
    <ph-input icon="magnifying-glass"
              clearable
              placeholder="Search folders"
              aria-label="Search folders"
              data-test="folder-picker-search"
              (input)="onSearchInput($event)"
              (ph-clear)="clearSearch()"></ph-input>

    <ph-scroll-area max-height="280px" data-test="folder-picker-tree">
        <ph-tree label="Folders"
                 dense
                 [items]="items"
                 [expanded]="expandedIds"
                 [active]="activeId"
                 [query]="searchQuery"
                 (ph-expand)="expandedIds = $event.detail"
                 (ph-select)="onSelect($event.detail.id)"></ph-tree>
    </ph-scroll-area>

    <ph-hint *ngIf="showPathPreview" data-test="folder-picker-path">{{ hasSelection ? pathDisplay : 'Select a folder above' }}</ph-hint>
</ph-stack>
